import React from 'react';
import { connect } from 'react-redux';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import _map from 'lodash/map';
import _toLower from 'lodash/toLower';
import PropTypes from 'prop-types';
// Core components
import Select from 'components/core/Select';
// Custom
import { countryShape } from 'constants/PropTypesShapes';
import { FlagImg } from 'components/img/AssetImg';

const CountryFieldSelector = ({
  countries, value, errorText, onChange, ...props
}) => (
  <Select
    label={<LocalizedMessage id="field.country" />}
    value={value}
    items={
      _map(countries, ({ code, label }) => (
        {
          key: code,
          value: code,
          label: label || <LocalizedMessage id={`country.${_toLower(code)}`} />,
          icon: <FlagImg width={25} countryCode={code} />,
        }
      ))
    }
    errorText={errorText}
    onChange={onChange}
    {...props}
  />
);

CountryFieldSelector.propTypes = {
  countries: PropTypes.arrayOf(countryShape),
  countriesScope: PropTypes.oneOf(['all', 'known']).isRequired, // eslint-disable-line react/no-unused-prop-types
  value: PropTypes.string,
  errorText: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  onChange: PropTypes.func.isRequired,
};

CountryFieldSelector.defaultProps = {
  countries: null,
  value: null,
  errorText: null,
};

const mapStateToProps = (state, ownProps) => ({
  countries: state.country[ownProps.countriesScope],
});

module.exports = connect(
  mapStateToProps,
  null,
)(CountryFieldSelector);



// WEBPACK FOOTER //
// ./components/inputFields/CountryFieldSelector.js